import { render, staticRenderFns } from "./ProductDropdown.vue?vue&type=template&id=2a4ce294&lang=pug&"
import script from "./ProductDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProductDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports